<template lang="html">
    <div id="finish-verify-page">
        <div class="finish-verify-page-content container-fluid">
          <div class="row">
            <div class="col-sm-12">
                Finished Email Verification: {{ verifyCode }}
            </div>

            <div class="col-12 col-md-9">
              <transition name="fade">
                <router-view></router-view>
              </transition>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
/**
 * @author Chenfeng Liu
 * @description API page will display the Documentations for UniBit's APIs.
 * @version 1.0
 * @module pages
 * @name FinishVerifyPage
 */

export default {
  components: {},

  data() {
    return {
      verifyCode: this.$route.params.vcode
    };
  },

  methods: {}
};
</script>
<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/static/finish-verify-page.vue